const state = {
  deleteLoading: false
};

const mutations = {
  changeDeleteLoading(state, val) {
    state.deleteLoading = val;
  }
};

export default {
  state,
  mutations
};
